import styled from "styled-components";

export const AppLoadingIndicator = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    font-size: ${props => props.theme.fontSize.xxLarge};
    height: 269px;
    @media ${props => props.theme.mediaQuery.sAndBelow} {
      height: 326px;
    }
`
